import React, { Component } from 'react'

export default class Payment extends Component {
    state = {
        checkoutResult: '',
    }
    componentDidMount() {
        let checkoutResult
        if (this.props.windowData.params.success) {
            checkoutResult = 'success'
        } else if (this.props.windowData.params.canceled) {
            checkoutResult = 'canceled'
        }
        this.setState({ checkoutResult })
    }
    render() {
        // console.log('window', this.props)

        return (
            <div>
                {this.state.checkoutResult == 'success' ? (
                    <div>
                        success
                    </div>
                ) : (
                    <></>
                )}
                {this.state.checkoutResult == 'canceled' ? (
                    <div>
                        your payment was successfuly failed.
                    </div>
                ) : (
                    <></>
                )}
            </div>


        )
    }
}
